var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"has-text-right"},[_c('a',{class:{
        button: true,
        'is-primary': true,
        'is-loading': _vm.isLoading,
        'is-disabled': _vm.isDisabled
      },on:{"click":function($event){return _vm.$emit('confirm')}}},[_vm._v(" "+_vm._s(_vm.confirmLabel || _vm.$t("main.confirmation"))+" ")]),_c('button',{staticClass:"button is-link",on:{"click":function($event){return _vm.$emit('cancel')}}},[_vm._v(" "+_vm._s(_vm.cancelLabel || _vm.$t('main.cancel'))+" ")])]),(_vm.isError)?_c('p',{staticClass:"error mt1 has-text-right"},[_vm._v(" "+_vm._s(_vm.errorText)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }